import {Component, HostBinding} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-route-loader',
  template: `
    <app-centered-spinner></app-centered-spinner>
  `,
  styles: [`
    :host {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(255,255,255,0.8);
      display:flex;
      flex-direction:column;
      justify-content: center;
      align-items:center;
      opacity: 0;
    }
  `],
  animations: [
    trigger('fadeInOut', [
      state('in', style({opacity: '1.0' })),
      transition('out => in', [
        style({opacity: '1.0'}),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({opacity: '0.0'}))
      ])
    ])
  ]
})
export class RouteLoaderComponent {
  @HostBinding('@fadeInOut')  fadeInOut = 'in'
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/route-loader/route-loader.component.ts